import classNames from "clsx";
import { isString, pascalCase } from "es-toolkit";
import { type ReactNode } from "react";
import styles from "./Typography.module.scss";
import {
  AllowedTypographyElement,
  TypographyProps,
} from "./Typography.types.ts";

export function Typography<TagName extends AllowedTypographyElement>({
  as: Component,
  className,
  children,
  variant = "body-l",
  ref,
  elementRef,
  ...restProps
}: TypographyProps<TagName>): ReactNode {
  const classes = classNames([
    styles.typography,
    styles[`variant${pascalCase(variant)}`],
    className,
  ]);

  return (
    // @ts-expect-error a type cast is needed because the types for the properties
    // of the AllowedCopyElement are disjoint/don't fully overlap.
    <Component
      className={classes}
      dangerouslySetInnerHTML={
        isString(children) ? { __html: children } : undefined
      }
      ref={elementRef || ref}
      {...restProps}
    >
      {isString(children) ? undefined : children}
    </Component>
  );
}
